'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroRadioGroup = require('./NitroRadioGroup');

var _NitroRadioGroup2 = _interopRequireDefault(_NitroRadioGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroRadioGroup2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-radio-group/index.js
// module id = 765
// module chunks = 4